import type { Form } from '@/payload-types'

const DEFAULT_SUCCESS_MESSAGE = 'Thanks! Your message has been sent.'

/** Reads confirmation message from a Form document (same as former Contact section logic). */
export function getFormConfirmationMessage(formDoc: Form): string {
  if (formDoc.confirmationType !== 'message') return DEFAULT_SUCCESS_MESSAGE

  const root = formDoc.confirmationMessage?.root
  if (!root || !Array.isArray(root.children)) return DEFAULT_SUCCESS_MESSAGE

  const collectText = (node: unknown): string[] => {
    if (!node || typeof node !== 'object') return []

    const typedNode = node as { children?: unknown[]; text?: string }
    const parts: string[] = []

    if (typeof typedNode.text === 'string' && typedNode.text.trim().length > 0) {
      parts.push(typedNode.text.trim())
    }

    if (Array.isArray(typedNode.children)) {
      typedNode.children.forEach((child) => {
        parts.push(...collectText(child))
      })
    }

    return parts
  }

  const message = root.children.flatMap((child) => collectText(child)).join(' ').trim()
  return message || DEFAULT_SUCCESS_MESSAGE
}
